import { QueryablePagedRequest } from './queryable-paged-request';

export class CollectionSearchRequest extends QueryablePagedRequest {
}
